import NoBreakSpan from './component.jsx'
export default NoBreakSpan
